export default "__VITE_ASSET__3f3043dc__"